import { ProductQuestionDto, QuestionDto } from '@maia/shared';
import { ComponentProps, ReactNode, useEffect, useMemo } from 'react';
import { useAppForm } from '../dynamic-form/dynamic-form';
import { FieldMapper } from '../dynamic-form/field-mapper';
import { calculateDefaultValues } from '../utils/calculate-default-values';

type FormProps = {
  questions: Array<QuestionDto | ProductQuestionDto>;
  onRevalidate?: () => void;
  onSubmit: () => void;
  showDebug?: boolean;
  submitButtonSlot?: ReactNode;
  validationSchema?: any;
} & Omit<ComponentProps<'form'>, 'onSubmit'>;

export function Form(props: FormProps) {
  const {
    questions,
    onRevalidate,
    onSubmit,
    showDebug,
    submitButtonSlot,
    validationSchema,
    ...rest
  } = props;

  const defaultValues = useMemo(
    () => calculateDefaultValues(questions),
    [questions],
  );

  useEffect(() => {
    form.reset();
  }, [questions]);

  const form = useAppForm({
    defaultValues,
    onSubmit: ({ value }) => onSubmit(value),
    validators: {
      onChange: validationSchema,
    },
  });

  return (
    <form
      {...rest}
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        form.handleSubmit();
      }}
    >
      <form.AppForm>
        {questions.map((question) => (
          <FieldMapper
            key={question.guid}
            form={form}
            question={question}
            onRevalidate={onRevalidate}
          />
        ))}
        {submitButtonSlot}
        {showDebug && <form.FormDebugger />}
      </form.AppForm>
    </form>
  );
}
